// Public entry points are classified centrally; unknown APIs still reach the
// server, whose service/controller remains the authorization authority.
const PUBLIC = new Set([
  '/user/login', '/user/loginDemo', '/user/register', '/user/resetMainPwd',
  '/config/getImageCode', '/sms/sendPhoneCode', '/config/findAppAgreementByType',
  '/config/findAppLatestEdition', '/user/hotelLogin',
  '/config/findCity', '/config/findWeatherList', '/config/findAirByNow',
  '/config/findAppIconList', '/config/findAppIconGroupList'
]);
const OPTIONAL = new Set(['/config/findAppAbout']);
export function authMode(config) {
  if (PUBLIC.has(config.url)) return 'anonymous';
  if (OPTIONAL.has(config.url)) return config.authMode || 'optional';
  return config.authMode || 'authenticated';
}
export function prepareAuth(config) {
  config.authMode = authMode(config);
  if (config.authMode === 'anonymous' && config.data && typeof config.data === 'object')
    config.data = { ...config.data, token: '' };
  return config;
}
